import { render, staticRenderFns } from "./PaginationArrow.vue?vue&type=template&id=2a219ed0&scoped=true&"
import script from "./PaginationArrow.vue?vue&type=script&lang=js&"
export * from "./PaginationArrow.vue?vue&type=script&lang=js&"
import style0 from "./PaginationArrow.vue?vue&type=style&index=0&id=2a219ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a219ed0",
  null
  
)

export default component.exports